const googleSiteTag = process.env.NODE_ENV === 'development' ? 'development' : 'UA-124898037-2';

export default googleSiteTag;
